import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
interface IPageAL2012 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Al2012Controller() {
    const vm: IPageAL2012 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
         { nom: 'dsimsg', largeur: 250 }
        ]
    };
}
